<h1 mat-dialog-title>{{ data.title | translate }}</h1>
<mat-dialog-content>
  {{ data.message | translate: data.params }}
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button cdkFocusInitial [mat-dialog-close]="true">{{ 'DIALOGS.OK' | translate }}</button>
</mat-dialog-actions>
